import { RoleType, RootRoleId } from './types';

const roleTypeMap: Record<RootRoleId, RoleType> = {
  [RootRoleId.Administrator]: RoleType.Administrator,
  [RootRoleId.Manager]: RoleType.Manager,
  [RootRoleId.User]: RoleType.User,
};

export const getRoleType = (roleId: string) =>
  roleTypeMap[roleId] ?? RoleType.Custom;

const roleLabels: Record<RootRoleId, string> = {
  [RootRoleId.Administrator]: 'Адміністратор',
  [RootRoleId.Manager]: 'Менеджер',
  [RootRoleId.User]: 'Користувач',
};

export const getRoleLabel = (roleId: string) => roleLabels[roleId] ?? '';

export const isRootRole = (roleId?: string) =>
  Object.values<string>(RootRoleId).includes(roleId);
